import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
export default {
  name: 'NiotaClassicDevicetypesPacketParserSingle',
  mixins: [formMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      parserConfigInternal: {}
    };
  },
  computed: {
    formElement: function formElement() {
      return this.$refs.form;
    }
  },
  watch: {
    parserConfig: {
      handler: function handler(val) {
        var clonedPropParserConfig = cloneDeep(val);
        this.parserConfigInternal = clonedPropParserConfig;
      },
      immediate: true
    }
  },
  methods: {
    onConfigChanged: function onConfigChanged(config) {
      this.parserConfigInternal = config;
      this.emitChanges();
    },
    emitChanges: function emitChanges() {
      var clonedConfig = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', clonedConfig);
    },
    onTypeDefinitionsUpdated: function onTypeDefinitionsUpdated(newVariables) {
      this.parserConfigInternal = _objectSpread(_objectSpread({}, this.parserConfigInternal), {}, {
        variables: newVariables
      });
      this.emitChanges();
    }
  }
};